const creditCards = {
  isLoading: {
    creditCards: false,
    newCreditCardForm: false,
  },
  permissionAllowed: true,
  availableCreditCards: [],
  newCreditCardForm: {
    cardReference: '',
    cardName: '',
    cardNumber: '',
    cardExpiryMonth: '',
    cardExpiryYear: '',
    cardCVV: '',
  },
}

const CreditCardsReducer = function (state = creditCards, action) {
  switch (action.type) {
    case 'TOGGLE_CREDIT_CARD_LOADING': {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.key]: action.value,
        },
      }
    }
    case 'SET_AVAILABLE_CREDIT_CARDS_PERMISSION': {
      return {
        ...state,
        permissionAllowed: action.value,
      }
    }
    case 'UPDATE_CHECKOUT_CREDIT_CARD_FORM': {
      return {
        ...state,
        newCreditCardForm: {
          ...state.newCreditCardForm,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_AVAILABLE_CREDIT_CARDS': {
      return {
        ...state,
        availableCreditCards: action.value,
      }
    }
    case 'CLEAR_NEW_CREDIT_CARD_FORM': {
      return {
        ...state,
        newCreditCardForm: {
          cardReference: '',
          cardName: '',
          cardNumber: '',
          cardExpiryMonth: '',
          cardExpiryYear: '',
          cardCVV: '',
        },
      }
    }
    default: {
      return state
    }
  }
}

export default CreditCardsReducer
